import { Component, DestroyRef, inject, Inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PlatformConfigService } from '../../../services/platform-config.service';

@Component({
  selector: 'dispatch-edit',
  templateUrl: './dispatch-edit.component.html',
  styleUrls: ['./dispatch-edit.component.scss']
})
export class DispatchEditComponent implements OnInit {
  private destroyRef = inject(DestroyRef);
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialogRef<DispatchEditComponent>,
    private platformConfigService: PlatformConfigService) { }

  public phoneNumber: string = "";
  public isLoading: boolean = false;

  ngOnInit() {
    if(this.data){
      this.phoneNumber = this.data.phone;
    }
  }

  save(){
    this.platformConfigService.putDispatchPhone(this.phoneNumber).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(phone => {
      this.dialog.close(this.phoneNumber);
    });
  }

}
